<div class="container vertical-center d-grid animated fadeIn fast">
    <div class="jumbotron-fluid vertical-center row">
      <div class="frame frame-account center-block">
        <div class="row">
          <img
            style="position: relative"
            class="center-block"
            src="assets/images/login/Frame.png"
          />
          <img
            style="position: absolute"
            class="logo-login"
            src="assets/images/login/logo-bf-vertical.png"
          />
        </div>
        <div class="row row-title text-center">
          <h3 class="title secondary">Crear o recuperar contraseña</h3>
          <h6 [hidden]="_stepper.stepper.hidden" class="text-right label-step">
            {{ _stepper.stepper.current }}/{{ _stepper.stepper.total }}
          </h6>
          <div id="space-bar" class="space-bar center-block"></div>
        </div>
        <div class="create-password-form center-block">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
  